import React, {useRef} from "react";
import "./SectionHeading2.css";
import {OutlinedLogoWhite} from "../../../assets/images";

const SectionHeading2 = ({
  title1,
  title2,
  description,
  leftSpace = true,
  image,
}) => {
  const sectionRef = useRef(null);

  return (
    <div
      className="section-heading-grid section-heading2-container"
      ref={sectionRef}
    >
      <div className="section-heading-content">
        <div className="section-wrapper" data-delay=".3">
          <h2 className="section-title" style={{perspective: "300px"}}>
            <span className="section-title-word">
              <span className="section-title-char">
                <span style={{display: "block", lineHeight: "1", margin: 0}}>
                  {title1}
                </span>
                <span style={{display: "block", lineHeight: "1", margin: 0}}>
                  {title2}
                </span>
              </span>
            </span>
          </h2>

          <div className="section-description">
            <p>{description}</p>
          </div>
        </div>
      </div>

      <div className="section-heading-image">
        {image && (
          <div className="section-image-wrapper">
            <img src={OutlinedLogoWhite} alt="OutlinedLogoWhite" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionHeading2;
